/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc
 */

export const validateTokenRpc = {
  serviceName: 'com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc',
  rpcName: 'validateToken',
  auth: 'external',
  fingerprint: 'FLV3IfjNpb3HV6kor6C01I3tybSReokV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEngagementDetailsRpc = {
  serviceName: 'com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc',
  rpcName: 'getEngagementDetails',
  auth: 'external',
  fingerprint: 'FLV3IfjNpb29DGn-UcCGlo3tybSReokV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNotesRpc = {
  serviceName: 'com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc',
  rpcName: 'getNotes',
  auth: 'external',
  fingerprint: 'FLV3IfjNpb3VUtiYmGVom43tybSReokV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRecordingRpc = {
  serviceName: 'com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc',
  rpcName: 'getRecording',
  auth: 'external',
  fingerprint: 'FLV3IfjNpb3ZZ8TEoGu6843tybSReokV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTranscriptRpc = {
  serviceName: 'com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc',
  rpcName: 'getTranscript',
  auth: 'external',
  fingerprint: 'FLV3IfjNpb1lwNJi_EZHFI3tybSReokV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSummaryRpc = {
  serviceName: 'com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc',
  rpcName: 'getSummary',
  auth: 'external',
  fingerprint: 'FLV3IfjNpb2isiF4RA-E-43tybSReokV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActionItemsRpc = {
  serviceName: 'com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc',
  rpcName: 'getActionItems',
  auth: 'external',
  fingerprint: 'FLV3IfjNpb0PYVV80_tP6Y3tybSReokV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getQAndARpc = {
  serviceName: 'com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc',
  rpcName: 'getQAndA',
  auth: 'external',
  fingerprint: 'FLV3IfjNpb0hQQaEl-ZwcY3tybSReokV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};